import React from 'react';
import MainLayout from '../../../app/layouts/MainLayout';
import { Card } from '../../../components/ui/Card';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';
import Avatar from '../../../components/ui/Avatar';
import { Filter, Plus, Search, Cake, Phone } from 'lucide-react';
import { students } from '../../../data/modules';
import { getPersonPhotoUrl } from '../../../utils/helpers/avatar';

const StudentsPage = () => {
  return (
    <MainLayout>
      <div className="space-y-6">
        <header className="flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-slate-900">Alunos</h2>
            <p className="text-sm text-gray-500">Lista inicial com matrícula e acompanhamento.</p>
          </div>
          <Button size="icon" className="h-12 w-12 shadow-md">
            <Plus size={24} />
          </Button>
        </header>

        <div className="flex gap-2">
          <div className="relative flex-1">
            <Input placeholder="Buscar por aluno ou classe..." className="pl-11" />
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
          </div>
          <Button variant="outline" size="icon" className="h-12 w-12 border-gray-200 text-gray-400">
            <Filter size={20} />
          </Button>
        </div>

        <div className="space-y-4">
          {students.map((student) => (
            <Card key={student.name} hoverable className="space-y-4 p-4">
              <div className="flex items-start justify-between gap-3">
                <div className="flex min-w-0 items-start gap-3">
                  <Avatar
                    src={getPersonPhotoUrl(student.name)}
                    alt={`Foto de ${student.name}`}
                    name={student.name}
                    className="h-12 w-12 shrink-0 rounded-2xl ring-1 ring-slate-200"
                  />
                  <div className="min-w-0">
                    <h3 className="truncate text-lg font-bold text-slate-900">{student.name}</h3>
                    <p className="truncate text-sm text-gray-500">{student.className}</p>
                  </div>
                </div>
                <span className="rounded-full bg-primary-light px-3 py-1 text-xs font-semibold text-primary">
                  {student.attendance}
                </span>
              </div>

              <div className="rounded-2xl bg-gray-50 p-3 text-sm">
                <p className="mb-1 text-[10px] font-bold uppercase tracking-wider text-gray-400">Situação</p>
                <p className="font-semibold text-slate-900">{student.status}</p>
              </div>

              <div className="flex gap-2">
                <button className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-gray-50 py-3 text-sm font-semibold text-slate-700">
                  <Phone size={16} />
                  Contato
                </button>
                <button className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-primary-light py-3 text-sm font-semibold text-primary">
                  <Cake size={16} />
                  Histórico
                </button>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default StudentsPage;
